import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-626ebdf7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "components__cnt-image" }
const _hoisted_2 = ["src"]

import { cntProps } from 'vue/applications/frontend/mixins/cnt-component';
 
  
export default /*#__PURE__*/_defineComponent({
  __name: 'cnt-images',
  props: {...cntProps()},
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentItem.files, (file) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "single-image-container",
        key: file.id
      }, [
        _createElementVNode("img", {
          src: file.url
        }, null, 8, _hoisted_2)
      ]))
    }), 128))
  ]))
}
}

})